module.exports = __webpack_public_path__ + "img/DropsmartsSecrets.4dc75816.png";